export default __webpack_public_path__ + "static/media/2136.f7e50756.png";